import React, { useState, useEffect, useMemo } from 'react'
import { useForm, Controller } from 'react-hook-form';
import {
    Input,
    Button,
    Typography,
    Spinner,
    Card,
    Textarea,
    IconButton,
    Switch,

} from "@material-tailwind/react";
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import AIcon from '../../components/partials/AIcon';
import { useShared } from '../../hooks/useShared';
import UploadPhoto from '../../components/upload/UploadPhoto';
import ABreadcrumbs from '../../components/breadcrumbs/ABreadcrumbs';
import AInput from '../../components/fields/AInput';
import ASelect from '../../components/fields/ASelect';
import ASwitch from '../../components/fields/ASwitch';
import APDate from '../../components/fields/APDate';
import { useParams } from 'react-router-dom';


const companyFields = [
    { label: 'نوع فعاليت', name: 'company_type', type: 'select', roles: [1], icon: 'text-outline', className: '', required: "نوع شرکت الزامی است", isStyle:false, options:[] },
    { label: 'اسم شرکت', name: 'name_af', type: 'text', roles: [1], icon: 'text-outline', className: '', required: false, isStyle:false },
    { label: 'اسم شرکت به انگلسی', name: 'name_en', type: 'text', roles: [1], icon: 'text-outline', className: '', required: "نام شرکت الزامی است" },
    { label: 'شماره جواز', name: 'license_number', type: 'text', roles: [1], icon: 'star-outline', className: '', required: "شماره جواز شرکت الزامی است" },
    { label: 'TIN شماره', name: 'tin_number', type: 'text', roles: [1], icon: 'star-outline', className: '', required: "شماره تین شرکت الزامی است"  },
    { label: 'ادرس شرکت به انگلسی', name: 'address', type: 'text', roles: [1], icon: 'location-outline', className: '', required: "ادرس شرکت الزامی است"},
    { label: 'تليفون', name: 'phone', type: 'text', roles: [1], icon: 'call-outline', className: '', required: false },
    { label: 'ايميل', name: 'email', type: 'email', roles: [1], icon: 'at-outline', className: '', required: false },
    { label: 'سال تائسيس', name: 'establishment_date', type: 'text', roles: [1], icon: 'calendar-outline', className: '', required: false },
    { label: 'مالک', name: 'owner', type: 'select', roles: [1], icon: null, className: '', required: false, options: [] },
    { label: 'زون فعاليت', name: 'zone', type: 'select', roles: [1], icon: null, className: '', required: "زون فعاليت شرکت الزامی است", options: [] },
    { label: 'Rex. Number', name: 'rex_number', type: 'text', icon: 'text-outline', roles: [1], className: '', required: false,},
    { label: 'حالت', name: 'status', type: 'switch', roles: [1], icon: 'book-outline', className: '', required: false },
    { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false },
    { label: 'لوګو', name: 'logo', type: 'logo', roles: [1], icon: 'book-outline', className: '' },
  ];





export default function NewCompany({ v }) {

    const { id } = useParams();

    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [fields, setFields] = useState([...companyFields])
    const { http, auth, com, funs,setModel,model, photo, setPhoto,navigate, uploadPhoto, location, consts, fetchModelCounts } = useShared();

    useEffect(() => {
        if (!auth.hasRole([1,2,23])) {
            return navigate("/db/notAllowed")
        }
      }, [])

    const { register, handleSubmit, control, formState: { errors }, reset, setValue } = useForm({
     /*    defaultValues: useMemo(() => {
            return location?.state?.model;
        }, [location?.state]) */
    });



    useEffect(() => {
        if(id>0){
            setModel(null)
            setLoading(true)
            http.get(`/api/companies/${id}`).then(res => {
                
                if (res.data.success && res.data.data) {
                    const data = res.data.data;
                   // if( data['establishment_date'] )
                   // data['establishment_date'] =  com.dateConvert(data["establishment_date"],false) // convert miladi to shamsi date
                  
                    reset(data)
                    setModel(data)
                    const img = data?.image_data?.path 
                    setPhoto({ url: img ? consts.BASE_URL + img : '', photo: null })  
                   
                }
                setLoading(false)
            }, err => {
                console.log('err');
                setLoading(true)
            })
        }
      
    }, [])

    const getCompanyTypes = (id) => {
        setLoading(true)
        http.post(`/api/categoryAdvanceSearch?typeId=${52}`).then(res => { //get company types
           
            if (res.data.success) {
                setLoading(pre => ({ ...pre, show: false }))
                companyFields[0].options = res.data?.data
                setFields(companyFields)
                setLoading(false)
            }
        }, err => {
            setLoading(false)
            console.log('getCompanyTypes error ', err);
        })
        
    }

    const getZones = ( ) => {
        console.log("getZones");
        setLoading(true)
         http.post('api/zonesAdvanceSearch', { nameId: true }).then(res => {
            console.log("czonesAdvanceSearch", res);
            if (res.data.success) {
               
                const data = res?.data?.data;
                companyFields[10].options  = data
                setFields(companyFields)
                setLoading(false)
            }
        }, err => {
            setLoading(false)
            console.log('getZones  error ', err);
        })


    }


    const getOwnersList = () => {
        setLoading(true)
       
        funs.getUserList().then(res => {
           
            if (res.success) {
                setLoading(pre => ({ ...pre, show: false }))
                companyFields[9].options = res.data
                setFields(companyFields)
                setLoading(false)
            }
        }, err => {
            setLoading(false)
            console.log('getOwnersList error ', err);
        })
    }


    useEffect(() => {
        getOwnersList()
        getCompanyTypes()
        getZones()
    }, [])


    const mReset = () => {
        reset({})
        fields.map(f=>{
            setValue(f.name, null)
        })
    }


    const submit = async (data) => {
        setErrorMessage(null)

      //  data =com.convetDateInObject(data, 'establishment_date')

       
        try {
            setLoading(true)
            const res = await http.post('api/companies', data);
            console.log('company ', res);
            if (res.data?.success) {
                mReset()
                const company = res.data?.data;
                if (company?.id && photo) {
                   
                    uploadPhoto(company?.attachment ).then(res => {
                       
                       navigate(-1)
                    });
                }
                else navigate(-1)
                toast.success(res.data.message);
               // fetchModelCounts()
            }

            setLoading(false)


        } catch (error) {
            setLoading(false)
            const err = error?.response?.data
            if (!err?.success) {
                setErrorMessage(err.message)
                toast.error(err.message);
            }
        }

    }


    return (
        <div>
            <ABreadcrumbs links={[{ name: 'شرکت‌ها', link: '/companies' }, { name: 'شرکت جديد', link: '/companies/new_company/0' }]} />
            <div className='md:flex  items-start gap-4'>

                <Card className="w-full md:w-[70%]  p-2 md:p-4 mt-4 relative">
                    <p className="text-sm text-main-color font-bold">معلومات شرکت جديد</p>
                    <form className=" flex flex-col gap-4 mt-4" onSubmit={handleSubmit(submit)}>
                        <div className=" grid  gap-6 items-baseline">

                            <div className='grid md:grid-cols-1 gap-4'>
                             
                                <fieldset className='border p-3 rounded-lg grid gap-4'>
                                  
                                    {
                                        fields?.map((data, i) => {
                                            return (
                                                <React.Fragment key={i}>
                                                    {
                                                        data?.type === 'text' || data.type === 'date'|| data?.type === 'number' || data?.type === 'textarea' || data?.type === 'password' || data?.type === 'email' ?
                                                            <AInput v={{ register, errors, data }} />
                                                            : data?.type === 'select' ? <ASelect v={{ register, errors, control, data }}  />
                                                                : data?.type === 'switch' ? <ASwitch v={{ register, errors, data }} />
                                                                    : data.type === 'pdate'  ? <APDate v={{ register, errors,setValue, control, data }} />
                                                                        : null
                                                    }
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                    <UploadPhoto v={{ obj: model?.image_data, className: "md:hidden ", title: 'Upload photo' }} />
                                </fieldset>
                            </div>
                        </div>
                        {errorMessage && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal "
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errorMessage}
                        </Typography>}
                        <div className='flex gap-4 md:justify-end'>
                            <Button className="btn1 w-full md:w-[10%]" size='sm' type="submit" disabled={loading}>  {loading ? <Spinner color="teal" className="h-4 w-4" /> : "ارسال"}    </Button>
                            <Button variant="outlined" size='sm' color="gray" onClick={() => mReset()}>Reset</Button>
                        </div>


                    </form>
                </Card>

                <UploadPhoto v={{ obj: model?.image_data, modelName:'Company', title: 'Upload Company Logo', className: "hidden md:block w-full  md:w-[30%]  p-2 md:p-4  relative" }} />

            </div>

            <ToastContainer />
        </div>
    )

}